var _rect, _g, _rect2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 30,
    fill: "url(#paint0_linear_25_71)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_25_71)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.0656,
    y: 50,
    width: 68.1223,
    height: 42.5764,
    rx: 21.2882,
    fill: "url(#paint1_linear_25_71)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.9999,
    width: 73.7991,
    height: 73.7991,
    rx: 30,
    fill: "url(#paint2_linear_25_71)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_25_71)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 30.9976C38.95 30.9976 30 39.912 30 50.918C30 59.7328 35.725 67.1781 43.675 69.8175C44.675 69.9918 45.05 69.3942 45.05 68.8713C45.05 68.3982 45.025 66.8295 45.025 65.1611C40 66.0825 38.7 63.941 38.3 62.8205C38.075 62.2478 37.1 60.4798 36.25 60.0067C35.55 59.6332 34.55 58.7119 36.225 58.687C37.8 58.6621 38.925 60.1312 39.3 60.7288C41.1 63.7418 43.975 62.8952 45.125 62.3723C45.3 61.0774 45.825 60.2059 46.4 59.7079C41.95 59.2099 37.3 57.4918 37.3 49.8722C37.3 47.7058 38.075 45.913 39.35 44.5186C39.15 44.0206 38.45 41.9787 39.55 39.2396C39.55 39.2396 41.225 38.7167 45.05 41.2815C46.65 40.8333 48.35 40.6092 50.05 40.6092C51.75 40.6092 53.45 40.8333 55.05 41.2815C58.875 38.6918 60.55 39.2396 60.55 39.2396C61.65 41.9787 60.95 44.0206 60.75 44.5186C62.025 45.913 62.8 47.6809 62.8 49.8722C62.8 57.5167 58.125 59.2099 53.675 59.7079C54.4 60.3304 55.025 61.5257 55.025 63.3932C55.025 66.0576 55 68.199 55 68.8713C55 69.3942 55.375 70.0167 56.375 69.8175C64.275 67.1781 70 59.7079 70 50.918C70 39.912 61.05 30.9976 50 30.9976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_25_71",
    x: 9.60555,
    y: 44.54,
    width: 79.0423,
    height: 53.4964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_25_71"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_25_71",
    x: 27,
    y: 28,
    width: 45,
    height: 45.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25_71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_71",
    x1: 8.40611,
    y1: 6.55022,
    x2: 82.6419,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_71",
    x1: 53.8348,
    y1: 93.8462,
    x2: 39.9491,
    y2: 44.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#1B1F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#363C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_71",
    x1: 55,
    y1: 88.9999,
    x2: 20.5,
    y2: 12.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0729167,
    stopColor: "#1B1F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#363C42"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/GithubIcon.0e6ae7439e9f6bdbb4c44fcc3bd27dfc.svg";
export { ForwardRef as ReactComponent };